import { render } from "./RequestsPage.vue?vue&type=template&id=c01d1626&scoped=true"
import script from "./RequestsPage.vue?vue&type=script&lang=js"
export * from "./RequestsPage.vue?vue&type=script&lang=js"

import "./RequestsPage.vue?vue&type=style&index=0&id=c01d1626&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c01d1626"]])

export default __exports__